export const FileDriverValues = {
    EXTERNAL: 'EXTERNAL',
    INTERNAL: 'INTERNAL',
};
